import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

export const NG_BOOTSTRAP_MODULES = [NgbModalModule];
